import React from 'react';
import ProductOptionsColor from './ProductOptionsColor.jsx';
import ProductOptionsSize from './ProductOptionsSize.jsx';
import ProductOptionsOther from './ProductOptionsOther.jsx';
import { map } from 'lodash';
import './ProductOptions.scss';

const ProductOptions = (props) => {
  const options = map(props.attributes, (a, idx) => {
    const attrName = a.fieldId;

    switch (a.kind) {
      case 0:
        return (
          <ProductOptionsColor
            values={a.values}
            attrName={attrName}
            updateSelection={props.handleUpdateSelection}
            isKit={props.isKit}
            selection={props.selection}
            name={a.name}
            isMobile={props.isMobile}
            options={props.options}
            qtySelected={props.qtySelected}
            key={idx}
          />
        );
      case 1:
        return (
          <ProductOptionsSize
            values={a.values}
            attrName={attrName}
            updateSelection={props.handleUpdateSelection}
            isKit={props.isKit}
            selection={props.selection}
            updateModalState={props.handleModalState}
            modalsState={props.modalsState}
            name={a.name}
            isMobile={props.isMobile}
            options={props.options}
            sizeChartRef={props.sizeChartRef}
            qtySelected={props.qtySelected}
            key={idx}
          />
        );
      case 2:
        return (
          <ProductOptionsOther
            values={a.values}
            attrName={attrName}
            updateSelection={props.handleUpdateSelection}
            isKit={props.isKit}
            selection={props.selection}
            updateModalState={props.handleModalState}
            modalsState={props.modalsState}
            nameAttributes={a.nameAttributes}
            kitOptionId={a.kitOptionId}
            name={a.name}
            slug={a.slug}
            isMobile={props.isMobile}
            options={props.options}
            attributes={props.attributes}
            qtyNeeded={a.quantityNeeded}
            qtySelected={props.qtySelected}
            key={idx}
          />
        );
      default:
        return <></>;
    }
  });

  return <>{options}</>;
};

export default ProductOptions;
